import { supabase } from '@/core/database/supabase';
import type { ProgressPhoto } from '../types/construction-progress.types';

export const ConstructionProgressPhotosService = {
  async getProgressPhotos(logId: string): Promise<ProgressPhoto[]> {
    const { data, error } = await supabase
      .from('construction_progress_photos')
      .select('*')
      .eq('progress_log_id', logId)
      .order('display_order', { ascending: true });

    if (error) throw error;
    return data as ProgressPhoto[];
  },

  async addPhoto(data: Partial<ProgressPhoto>): Promise<ProgressPhoto> {
    const { data: result, error } = await supabase
      .from('construction_progress_photos')
      .insert([data])
      .select()
      .single();

    if (error) throw error;
    return result as ProgressPhoto;
  },

  async deletePhoto(id: string): Promise<void> {
    const { error } = await supabase
      .from('construction_progress_photos')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
};
